import { render, staticRenderFns } from "./EndorsementByCategory.vue?vue&type=template&id=557a1c4c&"
import script from "./EndorsementByCategory.vue?vue&type=script&lang=js&"
export * from "./EndorsementByCategory.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementByCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports